import { render, staticRenderFns } from "./InstagramModal.vue?vue&type=template&id=3b4c0895&scoped=true&"
import script from "./InstagramModal.vue?vue&type=script&lang=js&"
export * from "./InstagramModal.vue?vue&type=script&lang=js&"
import style0 from "./InstagramModal.vue?vue&type=style&index=0&id=3b4c0895&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c0895",
  null
  
)

export default component.exports